type Args = {
  value: number;
  step: number;
  min: number | undefined;
  max: number | undefined;
};

export function currencyInputDelimiterGetStepValue({
  value,
  step,
  min,
  max,
}: Args) {
  const stepValue = value + step;

  if (typeof min !== 'undefined' && stepValue < min) return min;
  if (typeof max !== 'undefined' && stepValue > max) return max;

  return stepValue;
}
